'use client';

import viewProductsInWishlistTrigger from '@coolblue-development/ga4-events/triggers/Wishlist/viewProductsInWishlistTrigger';
import { TrackWhenVisible } from '@coolblue-development/next-analytics/client';
import { ReactElement } from 'react';

type Props = {
  productIds: number[];
  children: ReactElement;
};

export default function TrackedWishlistProductsView({ productIds, children }: Props) {
  const params = {
    item_ids: productIds.join(',')
  };

  return (
    <TrackWhenVisible trigger={viewProductsInWishlistTrigger(params)}>{children}</TrackWhenVisible>
  );
}
